import { UseSelectState, UseSelectStateChangeOptions, useSelect } from "downshift";
import { DropdownItem } from "../models";

export default function stateReducer(
  state: UseSelectState<DropdownItem>,
  actionAndChanges: UseSelectStateChangeOptions<DropdownItem>,
) {
  const { changes, type } = actionAndChanges;
  switch (type) {
    case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
    case useSelect.stateChangeTypes.ItemClick:
      return {
        ...changes,
        isOpen: true,
        highlightedIndex: state.highlightedIndex,
      };
    default:
      return changes;
  }
}
